//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import Dashboard from "layouts/Dashboard";
import AuthPages from "layouts/AuthPages";
import Redeem from "views/Dashboard/Redeem/Redeem";
import RedeemConfirmation from "views/Dashboard/Redeem/RedeemConfirmation";

var indexRoutes = [
  { path: "/dashboard", name: "Dashboard", component: Dashboard },
  { path: "/redeem", name: "Redeem", component: Redeem },
  {
    path: "/redeem-confirmation",
    name: "RedeemConfirmation",
    component: RedeemConfirmation,
  },
  { path: "/", name: "AuthPage", component: AuthPages },
];

export default indexRoutes;
